module.exports = __webpack_public_path__ + "static/img/2.ae8350f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxopen/2.png
// module id = b3g0
// module chunks = 1